@if (accountStatus != null) {
<div>
    <label class="header-label"><mat-icon style="vertical-align: middle; margin-right: 8px;">account_circle</mat-icon>{{ 'ai.accountStatus' | transloco }}: </label>
    <td style="padding-left: 32px"><label style="font-size: 18px; font-size: 32px; font-weight: bold;" [style.color]="accountStatusColor">{{accountStatus}}</label></td>
    <p>
        <label style="font-size: 12px; margin-left: 20px;">Last payment:</label>
        <label style="font-size: 12px; margin-left: 20px;">{{lastPaymentDate}}</label>
        <label style="font-size: 12px; margin-left: 20px;" [style.color]="lastPaymentColor">{{lastPaymentMessage}}</label>
    </p>
</div>
@if (showSubscribeButton()) {
    <button (click)="onResubscribe()" class="subButton" mat-raised-button style="background-color: green;" [disabled]="fintechService.busy"><mat-icon>replay</mat-icon>{{ 'ai.resubscribe' | transloco }}</button>
}
@if (showUnsubscribeButton()) {
<button (click)="onUnsubscribe()" class="subButton" mat-raised-button style="background-color: green;" [disabled]="fintechService.busy"><mat-icon>cancel</mat-icon>{{ 'account.unsubscribe' | transloco }}</button>
}
<hr>
}
